// Fecha 'AAAA-MM-DD' -> numero de serie de Excel (dias desde el 30/12/1899).
//
// No se usa un objeto Date local: SheetJS 0.18 lo convierte con el desfase HISTORICO de la zona horaria
// (en Mexico, en 1899 era -6:36:36) y una fecha a medianoche quedaba como el dia anterior a las 23:59;
// en el Excel se veia "ayer". Con el numero de serie, Excel muestra exactamente ese dia en cualquier zona.
// Si el texto no es una fecha, se regresa tal cual (vacio si no hay).
export const fechaASerialExcel = (texto) => {
  if (!texto) return "";
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(texto));
  if (!m) return texto;
  return (Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3])) - Date.UTC(1899, 11, 30)) / 86400000;
};
